const Select = ({
    label,
    name,
    value,
    options = [],
    onChange,
    className = "",
    columnClass = "col-md-2",
    selectedValue,
    isRequired = false,
    multiple = false,
    disabled = false,
    size,
    children,
    selectClassName = "",
    selectStyle,
    placeholder = "Select",
}) => {
    return (
        <div className={`${columnClass} ${className} select_container`}>
            <label className="form-label fw-semibold small">
                {label}
                {isRequired && <span className="required">*</span>}
            </label>
            <select
                className={`${
                    multiple ? "form-control" : "form-select"
                } ${selectClassName}`.trim()}
                style={selectStyle}
                name={name}
                value={multiple ? value ?? [] : value}
                onChange={
                    multiple
                        ? (e) =>
                              onChange({
                                  target: {
                                      name,
                                      value: Array.from(
                                          e.target.selectedOptions,
                                          (opt) => opt.value
                                      ),
                                  },
                              })
                        : onChange
                }
                multiple={multiple}
                disabled={disabled}
                size={size}
            >
                {!multiple && !selectedValue && (
                    <option value="">{placeholder}</option>
                )}
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
            {children}
        </div>
    );
};

export default Select;
